import * as ActionTypes from 'constants';

export const toggleRequestingCreatePlan = bool => ({ type: ActionTypes.TOGGLE_REQUESTING_CREATE_PLAN, payload: bool });
export const requestCreatePlan = plan => ({ type: ActionTypes.REQUEST_CREATE_PLAN, payload: plan });
export const createNewPlanSuccess = plan => ({ type: ActionTypes.CREATE_NEW_PLAN_SUCCESS, payload: plan });
export const initUpdatePlan = plan => ({ type: ActionTypes.INIT_UPDATE_PLAN, payload: plan });
export const toggleRequestingUpdatePlan = bool => ({ type: ActionTypes.TOGGLE_REQUESTING_UPDATE_PLAN, payload: bool });
export const requestUpdatePlan = plan => ({ type: ActionTypes.REQUEST_UPDATE_PLAN, payload: plan });
export const updatePlanSuccess = plan => ({ type: ActionTypes.UPDATE_PLAN_SUCCESS, payload: plan });
export const requestFetchPlans = options => ({ type: ActionTypes.REQUEST_FETCH_PLANS, payload: options });
export const fetchPlansSuccess = plans => ({ type: ActionTypes.FETCH_PLANS_SUCCESS, payload: plans });
export const initViewPlanDetails = plan => ({ type: ActionTypes.INIT_VIEW_PLAN_DETAILS, payload: plan });
export const toggleViewingPlanDetails = bool => ({ type: ActionTypes.TOGGLE_VIEWING_PLAN_DETAILS, payload: bool });
export const requestRemovePlan = plan_id => ({ type: ActionTypes.REQUEST_REMOVE_PLAN, payload: plan_id });
export const toggleRemovingPlan = bool => ({ type: ActionTypes.TOGGLE_REMOVING_PLAN, payload: bool });
export const removePlanSuccess = plan_id => ({ type: ActionTypes.REMOVE_PLAN_SUCCESS, payload: plan_id })



// WEBPACK FOOTER //
// ./src/common/actions/plans.js